import { useController } from 'react-hook-form';
import { InputGroup, Textarea } from 'rsuite';
import { FormGroup } from '@shared/ui/forms/display';

export default function BasicTextarea({
  error,
  control,
  name,
  isRequired = true,
  placeholder,
  validation,
  label,
  counter,
}) {
  const { field } = useController({
    control,
    name,
    rules: {
      required: isRequired,
      ...(validation && {
        validate: (value) => validation(value, counter),
      }),
    },
  });

  return (
    <FormGroup
      error={error}
      label={label}
      counter={
        counter && (
          <span>
            {field.value?.length || 0} / {counter}
          </span>
        )
      }
    >
      <InputGroup
        inside
        className={`${field.value ? 'has-value' : ''} textarea`}
      >
        <Textarea
          value={field.value || ''}
          placeholder={placeholder}
          onChange={field.onChange}
          rows={2}
        />
      </InputGroup>
    </FormGroup>
  );
}
